import script from "./ProfileSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSidebar.vue?vue&type=style&index=0&id=690c969d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690c969d"]])

export default __exports__